<script>
export default {
    filters: {
        noReferrence: (ref) => {
            return (ref) || 'n/a'
        }
    },
    props: {
        id: {
            type: Number,
            default: null
        },
        firstName: {
            type: String,
            default: null
        },
        lastName: {
            type: [Number, String],
            default: null
        },
        email: {
            type: String,
            default: null
        },
        status: {
            type: String,
            default: null
        }
    },
    data () {
        return {
            toggled: false
        }
    },
    methods: {
        updateUser() {
            this.$emit('update')
        }
    }
}
</script>
<template>
    <div :class="{'admin-item__control--toggled': toggled}" class="admin-item">
        <div class="admin-item__header">
            <div class="admin-item__label">
                {{ firstName }} {{ lastName }}
            </div>
            <div class="admin-item__control" @click="toggled = !toggled">
                <i class="fa fa-fw fa-info"/>
            </div>
        </div>
        <transition name="admin-item__content-animation">
            <div v-if="toggled" class="admin-item__content">
                <div class="admin-item__props">
                    <div class="admin-item__prop">
                        <div class="admin-item__prop-key">
                            {{ $t('adminItem.id') }}
                        </div>
                        <div class="admin-item__prop-value">
                            {{ id }}
                        </div>
                    </div>
                    <div class="admin-item__prop">
                        <div class="admin-item__prop-key">
                            {{ $t('adminItem.firstName') }}
                        </div>
                        <div class="admin-item__prop-value">
                            {{ firstName }}
                        </div>
                    </div>
                    <div class="admin-item__prop">
                        <div class="admin-item__prop-key">
                            {{ $t('adminItem.lastName') }}
                        </div>
                        <div class="admin-item__prop-value">
                            {{ lastName }}
                        </div>
                    </div>
                    <div class="admin-item__prop">
                        <div class="admin-item__prop-key">
                            {{ $t('adminItem.email') }}
                        </div>
                        <div class="admin-item__prop-value">
                            {{ email }}
                        </div>
                    </div>
                    <div class="admin-item__prop">
                        <div class="admin-item__prop-key">
                            {{ $t('adminItem.status') }}
                        </div>
                        <div class="admin-item__prop-value">
                            {{ status }}
                        </div>
                    </div>
                    <div class="admin-item__prop-edit">
                        <div class="admin-item__prop-edit-value">
                            <span class="admin-list__edit" @click="updateUser"><i class="fa fa-edit"/> {{ $t('admin.list.edit') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/AdminItem/AdminItem.vue